export default "__VITE_ASSET__DARmA2o3__"